export const useLifecycleStore = defineStore('lifecycle', () => {
  const attemptedSubmit = ref(false)
  const submitting = ref(false)
  const saveProgress = ref<OwnbitConfigurator.SaveProgress.Step>({ step: 'idle' })

  // In a frozen view, no navigations should be possible
  const isSaving = ref(false)
  useEventListener('beforeunload', event => {
    if (!isSaving.value) return
    event.returnValue = `Es wurden noch nicht alle Änderungen gespeichert. Möchten Sie die Seite  wirklich verlassen?`
  })

  return {
    attemptedSubmit,
    saveProgress,
    submitting,
    isSaving,
  }
})
